// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"a19f7d38dc156fa2","5285":"34b790b7f2d1ac7d"}[chunkId] + ".css";
};